import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { MovimientosJAView } from '../components/admin/MovimientosJAView';
import { OwnerContext } from '../types/actividad';
import { VolverButton } from '../components/ui/VolverButton';
import { rutaConPeriodo } from '../utils/periodoNavegacion';
import { nivelPanelBalance } from '../utils/permissions';

export const AdminMovimientosPage: React.FC = () => {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const nivelPanel = nivelPanelBalance(usuario);

  // Movimientos de la entidad propia: la diócesis para la JAD y su Junta Sacerdotal, la provincia
  // para la JAN y la suya. Ambas juntas los operan (puede_operar_dinero).
  let ownerContext: OwnerContext | null = null;
  if (nivelPanel === 'diocesano' && usuario?.diocesis_id) {
    ownerContext = { tipo: 'diocesis', id: usuario.diocesis_id, nombre: '' };
  } else if (nivelPanel === 'nacional' && usuario?.provincia_eclesiastica_id) {
    ownerContext = { tipo: 'provincia', id: usuario.provincia_eclesiastica_id, nombre: '' };
  }

  if (!ownerContext) {
    return (
      <div className="bg-white rounded-xl shadow-md border border-slate-200 p-8 text-center">
        <p className="text-slate-600">No tienes permisos para acceder a este módulo.</p>
      </div>
    );
  }

  const volverA = searchParams.get('volverA');
  const destinoVolver = rutaConPeriodo(
    volverA ? `/admin/balance?tab=${volverA}` : '/admin/balance',
    searchParams.toString()
  );

  return (
    <div className="space-y-6">
      <VolverButton onClick={() => { navigate(destinoVolver); }} label="Volver al balance" />
      <MovimientosJAView ownerContext={ownerContext} />
    </div>
  );
};
